import script from "./SidebarSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarSection.vue?vue&type=script&setup=true&lang=js"

import "./SidebarSection.vue?vue&type=style&index=0&id=8771d230&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8771d230"]])

export default __exports__